{
  "metadata": {
    "id": "matrix-light",
    "name": "Matrix",
    "description": "Портировано из темы «Matrix» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "matrix.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/matrix.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.452,
      "paletteMaxS": 0.511,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.4,
      "syntaxVsTextMinDeltaE": 16.9,
      "chartsMinDeltaE": 31.3,
      "textSeparationDeltaE": 11.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#179e3d",
      "hover": "#158e37",
      "active": "#138232",
      "foreground": "#000000",
      "muted": "#179e3d80",
      "emphasis": "#179e3d"
    },
    "surface": {
      "background": "#eef3ea",
      "foreground": "#203022",
      "muted": "#bec6bb",
      "mutedForeground": "#3c443d",
      "elevated": "#a7b0a5",
      "elevatedForeground": "#203022",
      "raised": "#8b968a",
      "raisedForeground": "#203022",
      "overlay": "#eef3ea33",
      "subtle": "#d6dcd2"
    },
    "interactive": {
      "border": "#848f83",
      "borderHover": "#b4bcb2",
      "borderFocus": "#179e3d",
      "selection": "#20302224",
      "selectionForeground": "#203022",
      "focus": "#179e3d59",
      "focusRing": "#179e3d47",
      "cursor": "#203022",
      "hover": "#20302217",
      "active": "#20302224"
    },
    "status": {
      "error": "#df0000",
      "errorForeground": "#ffffff",
      "errorBackground": "#df00001a",
      "errorBorder": "#df000059",
      "warning": "#647600",
      "warningForeground": "#ffffff",
      "warningBackground": "#6476001a",
      "warningBorder": "#64760059",
      "success": "#127f31",
      "successForeground": "#ffffff",
      "successBackground": "#127f311a",
      "successBorder": "#127f3159",
      "info": "#0072b5",
      "infoForeground": "#ffffff",
      "infoBackground": "#0072b51a",
      "infoBorder": "#0072b559"
    },
    "pr": {
      "open": "#127f31",
      "draft": "#49534a",
      "blocked": "#647600",
      "merged": "#bf5cff",
      "closed": "#df0000"
    },
    "syntax": {
      "base": {
        "background": "#bec6bb",
        "foreground": "#203022",
        "comment": "#49534a",
        "keyword": "#7900c7",
        "string": "#0d5b23",
        "number": "#7a4300",
        "function": "#045a4e",
        "variable": "#203022",
        "type": "#4a5700",
        "operator": "#045a4e"
      },
      "tokens": {
        "commentDoc": "#49534a",
        "stringEscape": "#045a4e",
        "keywordImport": "#7900c7",
        "storageModifier": "#7900c7",
        "functionCall": "#045a4e",
        "method": "#045a4e",
        "variableProperty": "#045a4e",
        "variableOther": "#203022",
        "variableGlobal": "#7a4300",
        "variableLocal": "#045a4e",
        "parameter": "#203022",
        "constant": "#7a4300",
        "class": "#4a5700",
        "className": "#4a5700",
        "interface": "#4a5700",
        "struct": "#4a5700",
        "enum": "#4a5700",
        "typeParameter": "#4a5700",
        "namespace": "#4a5700",
        "module": "#7900c7",
        "tag": "#7900c7",
        "jsxTag": "#7900c7",
        "tagAttribute": "#045a4e",
        "tagAttributeValue": "#0d5b23",
        "boolean": "#7a4300",
        "decorator": "#7900c7",
        "label": "#045a4e",
        "regexp": "#0d5b23"
      }
    },
    "charts": {
      "series": [
        "#179e3d",
        "#0072b5",
        "#127f55",
        "#647600",
        "#df0000"
      ]
    },
    "chat": {
      "background": "#eef3ea",
      "userMessage": "#203022",
      "userMessageBackground": "#a7b0a5",
      "assistantMessage": "#203022",
      "assistantMessageBackground": "#bec6bb",
      "timestamp": "#49534a",
      "divider": "#848f83",
      "typing": "#49534a"
    },
    "loading": {
      "spinner": "#179e3d",
      "spinnerTrack": "#bec6bb",
      "skeleton": "#bec6bb",
      "shimmer": "#b5bdb2"
    },
    "tools": {
      "background": "#bec6bb",
      "border": "#848f83",
      "headerHover": "#b6beb3",
      "icon": "#127a2f",
      "title": "#203022",
      "description": "#49534a",
      "edit": {
        "added": "#127f31",
        "addedBackground": "#127f311a",
        "removed": "#df0000",
        "removedBackground": "#df00001a",
        "modified": "#0072b5",
        "modifiedBackground": "#0072b51a",
        "lineNumber": "#49534a"
      }
    },
    "markdown": {
      "heading1": "#203022",
      "heading2": "#203022",
      "heading3": "#203022",
      "heading4": "#203022",
      "link": "#127f31",
      "linkHover": "#127c30",
      "inlineCode": "#0d5b23",
      "inlineCodeBackground": "#bec6bb",
      "blockquote": "#49534a",
      "blockquoteBorder": "#848f83",
      "listMarker": "#169a3b",
      "bold": "#203022",
      "italic": "#203022e6",
      "strikethrough": "#49534a",
      "hr": "#848f83"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393c",
        "foreground": "#ffffff",
        "contrast": 7.69
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c58c71",
        "foreground": "#000000",
        "contrast": 7.36
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d1ba71",
        "foreground": "#000000",
        "contrast": 10.97
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#afc654",
        "foreground": "#000000",
        "contrast": 11.03
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718f42",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#52c450",
        "foreground": "#000000",
        "contrast": 9.37
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#77c985",
        "foreground": "#000000",
        "contrast": 10.48
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e6d",
        "foreground": "#000000",
        "contrast": 5.33
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#74d2c1",
        "foreground": "#000000",
        "contrast": 11.73
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4ca2c1",
        "foreground": "#000000",
        "contrast": 7.25
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#385889",
        "foreground": "#ffffff",
        "contrast": 7.18
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#403fb7",
        "foreground": "#ffffff",
        "contrast": 8.04
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#886ec1",
        "foreground": "#000000",
        "contrast": 5.05
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a045bc",
        "foreground": "#ffffff",
        "contrast": 5.16
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#92367a",
        "foreground": "#ffffff",
        "contrast": 6.93
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#cc698a",
        "foreground": "#000000",
        "contrast": 5.96
      }
    ]
  }
}
